<kendo-treelist [ngClass]="{'kgrid-fullscreen' : enableFullscreen }" kendoTreeListExpandable [kendoTreeListHierarchyBinding]="menuData" childrenField="subMenu" style="width: 100%;" [height]="checkGridHeight()">
  <ng-template kendoTreeListToolbarTemplate>
      <div class="k-grid-toolbar-content d-flex">
          <div class="flex-grow-1 mat-panel-headerbar"></div>
          <div class="pagination-container" style="width: 28%">
              <div style=" width: 96%;">
                  <EIPAutoComplete style="width: 400px;" ShowTextValueField='N' WaterMarkText="Business Group *" TextField="group_Name" ValueField="group_Id" [dataSource]='businessGroupList' setId="ddMrlBusGrpId" (valueChange)='changeBusinessGroup($event)' [IsCascading]='true'>
                  </EIPAutoComplete>
              </div>
          </div>
          <div class="divider-container d-none d-md-block" id="imgDivider">
              <span></span>
          </div>
          <div class="icons-container">
              <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
              <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                  <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                      <div class="icon-wrap" *ngIf="menuData.length != 0">
                          <i class="fa fa-save eip-pl-xs-0" (click)="submitMapped()" aria-hidden="true" id="" title="Save"></i>
                          <span class="list-icon-name">Save</span>
                      </div>
                      <div class="icon-wrap" (click)="toggleFullscreen()">
                          <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                          <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </ng-template>
  <kendo-treelist-column [expandable]="true" field="displayName" title="Menu" [width]="250" [locked]="true">
      <ng-template kendoTreeListCellTemplate let-dataItem>
          <mat-checkbox [checked]="menuHeader[dataItem.menuId]" (change)='checkAllRoles($event.checked,dataItem.menuId)'></mat-checkbox>
          {{dataItem.displayName}}
      </ng-template>
  </kendo-treelist-column>
  <kendo-treelist-column [width]="120" *ngFor="let role of rolesList; let index = index">
      <ng-template kendoTreeListHeaderTemplate let-dataItem>
          <mat-checkbox [disabled]="!menuData.length" [checked]="roleHeader[role.dedId]" (change)="checkAllMembers($event.checked,role.dedId)">
          </mat-checkbox>
          <span title="{{role.dedDescription}}" class="eip-ml-5">{{role.dedDescription}}</span>
      </ng-template>
      <ng-template kendoTreeListCellTemplate let-dataItem>
          <mat-checkbox [checked]="isChecked(dataItem.menuId,role.dedId)" (change)="mapMemberRole($event.checked,dataItem.menuId,role.dedId)">
          </mat-checkbox>
      </ng-template>
  </kendo-treelist-column>
  <kendo-treelist-column [width]="1" [locked]="false">
  </kendo-treelist-column>
</kendo-treelist>